import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-target-system',
  templateUrl: './target-system.component.html',
  styleUrls: ['./target-system.component.scss']
})
export class TargetSystemComponent implements OnInit {
  @ViewChild('targetTable', { static: true })
  public targetTable: Table;
  
  public loading: boolean = false;
  
  targetTableData= [
    {
      'GeoId': 447, 
      'CropId': 1,
      'ProgId': 3,
      'Area': 42,
      'FarmersToBeBenefitted': 119,
      'Amount': 11865000,
      'StartDate': '01-04-2023',
      'EndDate': '30-06-2023'
    }
  ]
  constructor(
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
  ) { }

  ngOnInit(): void {
    
  }

  refreshTable(){

  }

  addTarget(){
    
  }

}
